module.exports = __FOREMAN_VENDOR__APOLLO_CLIENT_LINK_BATCH_HTTP__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__APOLLO_CLIENT_LINK_BATCH_HTTP__"
// module id = @apollo/client/link/batch-http
// module chunks = 0 1 2